
import { defineComponent, PropType } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import IssueDetailMixin from '~/mixins/issueDetailMixin'

import { UiIssueLevel } from '~/utils/issue'
import { prCopyText } from '~/utils/ui'

export default defineComponent({
  name: 'IgnoreIssueAllFiles',
  mixins: [IssueDetailMixin, ActiveUserMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      required: false
    },
    shortcode: {
      type: String,
      required: false
    },
    issueLevel: {
      type: String as PropType<UiIssueLevel>,
      default: UiIssueLevel.Repository
    },
    providerShortcode: {
      type: String as PropType<string | null>,
      default: null
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    UiIssueLevel() {
      return UiIssueLevel
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    },
    computedProviderShortcode() {
      const routeMeta = this.$providerMetaMap[this.$route.params.provider]
      return this.providerShortcode ?? routeMeta?.shortcode ?? null
    },
    issueLevelCopy() {
      return this.issueLevel === UiIssueLevel.Repository
        ? 'repository'
        : this.issueLevel === UiIssueLevel.Check
          ? prCopyText(this.computedProviderShortcode)
          : ''
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {
        repoIssueId: this.issue.id
      } as {
        repoIssueId?: string
        checkId?: string
        issueShortcode?: string
      }

      if (this.checkId) {
        delete params.repoIssueId
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueRepository(params)
        this.$toast.success(`${this.issueShortcode} ignored for all files in this repository.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore Issue',
          {
            method: 'Ignore Issue All Files',
            ...params
          },
          'Something went wrong while ignoring this issue, please contact support.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
